export var version = '3.6.5';
//# sourceMappingURL=version.js.map